class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#CartDrawer-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelectorAll(".cart-open-trigger");
		cartLink.forEach((links) => {
			links.setAttribute("role", "button");
			links.setAttribute("aria-haspopup", "dialog");
			links.addEventListener("click", (event) => {
				event.preventDefault();
				this.open(links);
			});
			links.addEventListener("keydown", (event) => {
				if (event.code.toUpperCase() === "SPACE") {
					event.preventDefault();
					this.open(links);
				}
			});
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty")
					? this.querySelector(".drawer__inner-empty")
					: document.getElementById("CartDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add("overflow-hidden");
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden");
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open")
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector(".drawer__inner").classList.contains("is-empty") &&
			this.querySelector(".drawer__inner").classList.remove("is-empty");
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
            document.getElementById('cart-icon-bubble').classList.remove('hidden')
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			sectionElement.innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector
			);
		});

		setTimeout(() => {
			this.querySelector("#CartDrawer-Overlay").addEventListener(
				"click",
				this.close.bind(this)
			);
			this.open();
		});
	}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble",
			},
			{
				id: "cart-icon-bubble-mobile",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
			{
				id: "cart-icon-bubble-mobile",
				section: "cart-icon-bubble-mobile",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);


$(document).ready(function(){
  loadDrawerRecomendations()
})
async function loadDrawerRecomendations(){
  //console.log('Entra a Cargar productos')
  let cart = await getCurrentCart()
  if(cart.items.length > 0){
    let ProductId = cart.items[0].product_id
    //console.log('Carga productos con '+cart.items[0].title)
    await fetch('https://us.shasa.com/recommendations/products?section_id=template--24343277830511__product-recommendations&product_id='+ProductId)
        .then((response) => response.text())
        .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(
                'product-recommendations'
            );
            if (recommendations && recommendations.innerHTML.trim().length) {
              const splideTrack = document.createElement('div');
              splideTrack.className = 'splide__track';
              
              const splideList = document.createElement('ul');
              splideList.className = 'splide__list';
              const parser = new DOMParser();
              const doc = parser.parseFromString(recommendations.innerHTML, 'text/html');
              const liElements = doc.querySelectorAll('li');
              liElements.forEach(li => {
                const slide = document.createElement('li');
                slide.className = `${li.className} splide__slide`;
                slide.innerHTML = li.innerHTML; // Copiar el contenido del <li>
                splideList.appendChild(slide);
              });
              splideTrack.appendChild(splideList);
                $('.dpl').html(splideTrack)
              $('.dpl').prepend('<h3 >You may also like</h3>')
              new Splide('.dpl', {
                type: 'loop',
                perPage: 4,
                perMove: 1,
                focus  : 0,
                omitEnd: true,
                breakpoints: {
                  600: {
                    perPage: 3, // 2 slides visibles en pantallas <= 768px
                  },
                  400: {
                    perPage: 2, // 1 slide visible en pantallas <= 480px
                  },
                },
              }).mount()
            }
        })
        .catch((e) => {
          console.log('Hay un error')
            console.error(e);
        });
    colorSwatches()
  }
}

async function getCurrentCart() {
	let cart
    await fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        return response.json().then(error => { throw new Error(error.message); });
      }
      return response.json();
    })
    .then(data => {
        cart = data
    })
    .catch((error) => {
      console.error('Error:-', error);
    });
  //console.log('Found Cart')
  //console.log(cart)
    return cart
  }

